import { Box, Avatar, Badge, Text, Flex, Image, Divider, Tooltip, Select, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Slider, SliderTrack, SliderFilledTrack, SliderThumb, Button, ModalFooter, CircularProgress, CircularProgressLabel, Popover, PopoverTrigger, IconButton, PopoverContent, PopoverArrow, PopoverCloseButton, PopoverBody, Input } from "@chakra-ui/react";
import DepartmentFrame from "../../../../../assets/images/DepartmentFrame.svg"
import BranchFrame from "../../../../../assets/images/BranchFrame.svg";
import EmailFrame from "../../../../../assets/images/EmailFrame.svg";
import PhoneFrame from "../../../../../assets/images/PhoneFrame.svg";
import GenderFrame from "../../../../../assets/images/GenderFrame.svg";
import UploadImageIcon from "../../../../../assets/images/CameraIcon.svg";
import CalenderFrame from "../../../../../assets/images/CalenderFrame.svg";
import PayrollFrame from "../../../../../assets/images/PayrollFrame.svg";
import ShiftFrame from "../../../../../assets/images/ShiftFrame.svg";
import BackgroundProfile from "../../../../../assets/images/ProfileBackground.jpg";
import DummyPerson from "../../../../../assets/images/DummyPerson.svg"
import CopyIcon from "../../../../../assets/images/CopyIcon.svg"
import MyDiv from "./profileDetailCard.style";
import React, { useEffect, useRef, useState } from "react";
import { ProfileDetail, props, StatusDD, CroppedAreaPixels } from './modal';
import { AlertCard, CustomToast } from '../../../../../components';
import { useFetch, baseUrl } from '../../../../../hooks/useFetch';
import { useAuth } from "../../../../../hooks/useAuth";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, } from '@chakra-ui/react'
import * as routesNames from '../../../../../constants/routes'
import imageCompression from "browser-image-compression";
import { ChevronDownIcon, EditIcon, TimeIcon } from "@chakra-ui/icons";
import Cropper from "react-easy-crop";
import { showDate } from "../../../../../utilities/helper";

const ProfileDetailCard = ({ employeeId, myProfile }: props) => {
  const [employee, setEmployee] = useState<ProfileDetail | null>(null);
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<CroppedAreaPixels>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const { loginObj, hasPermission } = useAuth();
  const modalDisclosure = useDisclosure();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [pendingStatus, setPendingStatus] = useState<string>("");
  const [statusDD, setStatusDD] = useState<StatusDD[]>([]);
  const canUpdateProfileCompletion = hasPermission("Employee", "updateProfileCompletion");
  const [isUpdatingProfile, setIsUpdatingProfile] = useState(false);
  const [remarkText, setRemarkText] = useState<string>("");
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [statusHistory, setStatusHistory] = useState<any[]>([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [isSendingAppointment, setIsSendingAppointment] = useState(false);
  const [isNamePopoverOpen, setIsNamePopoverOpen] = useState(false);
  const [editedName, setEditedName] = useState(employee?.name || "");
  const [lastWorkingDay, setLastWorkingDay] = useState<string>("");
  const REQUIRES_LWD = ["Terminated", "Release", "Abscond"];
  const pendingStatusName = statusDD.find((s) => s.id.toString() === pendingStatus)?.employeeStatus;


  const [alertConfig, setAlertConfig] = useState<{ description: string; colorScheme: string; onConfirm: () => void; } | null>(null);
  const handleStatusChange = (newStatus: string) => {
    setPendingStatus(newStatus);
    setRemarkText("");
    setLastWorkingDay("");
    setIsRemarkModalOpen(true);
  };
  const PROFILE_WEIGHTS = {
    personal: 25, employer: 25, family: 10, education: 15, bank: 10, documents: 15
  };
  const profilePercent = employee?.profileCompletion?.totalPercentage ?? 0;
  const getProfileColor = (percent: number) => {
    if (percent <= 40) return "red.400";
    if (percent <= 70) return "yellow.700";
    return "green.400";
  };
  const handleConfirmStatusChange = async () => {
    if (!remarkText || remarkText.trim() === "") {
      addToast({ message: "Remark is required.", status: "warning" });
      return;
    }

    if (REQUIRES_LWD.includes(pendingStatusName ?? "") && !lastWorkingDay) {
      addToast({ message: "Last Working Day is required.", status: "warning" });
      return;
    }

    if (pendingStatus && employee) {
      try {
        const payload = {
          employeeId: employee.id,
          employeeStatusId: Number(pendingStatus),
          remark: remarkText,
          lastWorkingDay: REQUIRES_LWD.includes(pendingStatusName ?? "") ? lastWorkingDay : null,
        };
        const response = await fetchApi(`Hrlense_Employee/toggleEmpStatus/${employee.id}`, "PUT", payload, "", "");
        if (response) {
          const updatedStatusName = statusDD.find((s) => s.id.toString() === pendingStatus)?.employeeStatus;
          if (updatedStatusName) {
            setEmployee((prev) => prev ? { ...prev, status: updatedStatusName } : prev);
          }
          addToast({ message: "Status updated successfully.", status: "success" });
          profileDetail();
          setIsRemarkModalOpen(false);
        }
      } catch (error) {
        addToast({ message: "An error occurred while updating status.", status: "error" });
      }
    }
  };


  const fetchStatusHistory = async () => {
    setIsHistoryLoading(true);
    setIsHistoryModalOpen(true);
    try {
      const response = await fetchApi(`Hrlense_EmployeeStatus/statusHistory`, "GET", null, `employeeId=${employeeId}`, "");
      if (response) {
        setStatusHistory(response);
      }
    } catch (error) {
      addToast({ message: "Failed to load status history.", status: "error" });
    } finally {
      setIsHistoryLoading(false);
    }
  };



  const updateProfileCompletion = async () => {
    try {
      setIsUpdatingProfile(true);
      const response = await fetchApi(
        "Tds_Slab/update-profile", "POST", employeeId, "", "");
      if (response) {
        addToast({ message: "Profile recalculated successfully", status: "success" });
        profileDetail();
      }
    } catch (error) {
      addToast({ message: "Failed to update profile", status: "error" });
    } finally {
      setIsUpdatingProfile(false);
    }
  };

  const EmployeeStatusDD = async () => {
    try {
      const response = await fetchApi("DropDown/EmplyeeStatus", "GET", null, "", "");
      if (response?.length > 0) {
        let modifiedStatusDD = response.filter((item: any) =>
          ["Active", "Terminated", "Release", "Abscond", "Inactive"].includes(item.employeeStatus)
        );
        setStatusDD(modifiedStatusDD);
      } else {
        addToast({ message: "Empty employee status dropdown.", status: "error" });
      }
    } catch (error) {
      console.error("Failed to load employee status", error);
    }
  };



  async function fetchAvatar() {
    try {
      const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${employeeId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${loginObj?.token || ""}`,
        },
      });
      if (!res.ok) throw new Error("Failed to load avatar");
      const blob = await res.blob();
      setAvatarUrl(URL.createObjectURL(blob));
    } catch (err) {
      console.error("Error fetching avatar", err);
    }
  }

  async function profileDetail() {
    const response = await fetchApi('Hrlense_Employee/profileCard', "GET", null, `employeeId=${employeeId}`, "");
    if (response) {
      setEmployee(response);
    }
  }

  useEffect(() => {
    profileDetail();
    fetchAvatar();
    EmployeeStatusDD();
  }, [employeeId]);

  useEffect(() => {
    if (employee?.name) {
      setEditedName(employee.name);
    }
  }, [employee]);

  const triggerAvatarUpload = () => {
    fileInputRef.current?.click();
  };

  const handleAvatarUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      addToast({ message: "Only JPEG or PNG images are allowed.", status: "error" });
      return;
    }

    // show crop modal with preview
    const imgUrl = URL.createObjectURL(file);
    // revoke previous selectedImage if present
    setSelectedImage((prev) => {
      if (prev && prev.startsWith("blob:")) URL.revokeObjectURL(prev);
      return imgUrl;
    });

    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
    setCropModalOpen(true);
    modalDisclosure.onOpen();
  };
  const ProfileTooltip = ({ tabs }: { tabs: any }) => {
    return (
      <Box p={2}>
        {Object.entries(PROFILE_WEIGHTS).map(([key, max]) => (
          <Flex key={key} justify="space-between" align="center" gap={4} fontSize="12px" mb={1} >
            <Text textTransform="capitalize" color="gray.600">
              {key}
            </Text>
            <Text fontWeight="600">
              {tabs?.[key] ?? 0} / {max}
            </Text>
          </Flex>
        ))}
      </Box>
    );
  };

  // helper: draw and get cropped blob resized to outputSize (600)
  const getCroppedImg = (imageSrc: string, pixelCrop: CroppedAreaPixels, outputSize = 600) => {
    return new Promise<Blob | null>((resolve, reject) => {
      if (!pixelCrop) {
        resolve(null);
        return;
      }
      const image = document.createElement("img") as HTMLImageElement;
      image.crossOrigin = "anonymous";
      image.src = imageSrc;

      image.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = outputSize;
        canvas.height = outputSize;

        const ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("Failed to get canvas context"));
          return;
        }

        // draw the cropped area to the canvas and scale to outputSize
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          outputSize,
          outputSize
        );

        canvas.toBlob((blob) => { resolve(blob); }, "image/jpeg", 0.9);
      };

      image.onerror = () => {
        reject(new Error("Image load error"));
      };
    });
  };

  // upload final cropped file to server
  const uploadCroppedImage = async (file: File) => {
    try {
      // optionally compress further using browser-image-compression
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1200,
        useWebWorker: true,
      };
      let processedFile = file;
      try {
        processedFile = await imageCompression(file, options);
      } catch (e) {
        // if compression fails just use original file.
        console.warn("Compression failed, using original file", e);
      }

      const data = new FormData();
      data.append("profilePic", processedFile);
      const response = await fetchApi("Hrlense_Employee/profilePic", "POST", data, "", "", true);

      if (response) {
        // create preview from processedFile
        const previewURL = URL.createObjectURL(processedFile);
        setAvatarUrl((prev) => {
          if (prev && prev.startsWith("blob:")) URL.revokeObjectURL(prev);
          return previewURL;
        });

        addToast({ message: "Profile image uploaded successfully.", status: "success" });

        // notify other parts of app
        window.dispatchEvent(new CustomEvent("avatarUpdated", { detail: previewURL }));

        // close modal
        setCropModalOpen(false);
        modalDisclosure.onClose();

        // cleanup selectedImage preview URL
        setSelectedImage((prev) => {
          if (prev && prev.startsWith("blob:")) URL.revokeObjectURL(prev);
          return null;
        });
      } else {
        addToast({ message: "Failed to upload image. Please try again.", status: "error" });
      }
    } catch (error) {
      console.error(error);
      addToast({ message: "Failed to upload image. Please try again.", status: "error" });
    }
  };

  const onCropComplete = (_: any, croppedPixels: CroppedAreaPixels) => {
    setCroppedAreaPixels(croppedPixels);
  };

  const applyCrop = async () => {
    try {
      if (!selectedImage || !croppedAreaPixels) {
        addToast({ message: "No image selected or crop area is empty.", status: "error" });
        return;
      }

      const blob = await getCroppedImg(selectedImage, croppedAreaPixels, 600);
      if (!blob) {
        addToast({ message: "Could not crop image. Try again.", status: "error" });
        return;
      }

      const file = new File([blob], "profile.jpg", { type: "image/jpeg" });
      await uploadCroppedImage(file);
    } catch (err) {
      console.error(err);
      addToast({ message: "Error cropping image. Please try again.", status: "error" });
    }
  };

  const infoItems = [
    { icon: DepartmentFrame, label: "Department", value: employee?.department },
    { icon: BranchFrame, label: "Branch", value: employee?.branch },
    { icon: EmailFrame, label: "Email", value: employee?.email },
    { icon: PhoneFrame, label: "Phone", value: employee?.phone },
    { icon: GenderFrame, label: "Gender", value: employee?.gender },
    { icon: CalenderFrame, label: "Age / DOB", value: `${employee?.age}, (${showDate(employee?.dob)})`, },
    { icon: PayrollFrame, label: "Payroll Company", value: employee?.payrollCompany, },
    { icon: PayrollFrame, label: "Company", value: employee?.usCompany, },
    { icon: ShiftFrame, label: "Shift", value: employee?.shift },
  ];
  const copyToClipboard = (text: string, type: string) => {
    navigator.clipboard.writeText(text);
    addToast({ message: `${type} copied!`, status: 'success' });
  }

  const sendAppointmentLetter = async () => {
    setIsSendingAppointment(true);

    const response = await fetchApi("AppointmentLetter/AppointmentLetter", "GET", "", `employeeId=${employeeId}`);
    if (response) {
      addToast({ message: "Appointment letter sent successfully.", status: "success" });
    }
    setIsSendingAppointment(false);

  }

  const updateEmployeeName = async () => {
    if (!editedName.trim()) {
      addToast({ message: "Name is required.", status: "warning", });
      return;
    }

    const name = editedName.trim();

    const nameRegex = /^[A-Za-z .'-]+$/;

    if (!nameRegex.test(name)) {
      addToast({
        message: "Only letters, spaces, hyphens (-), apostrophes ('), and periods (.) are allowed.",
        status: "warning",
      });
      return;
    }

    try {
      const payload = { employeeId: employee?.id, name: editedName.trim(), };
      const response = await fetchApi("Hrlense_Employee/updateEmployeeName", "PUT", payload, "", "");
      if (response) {
        setEmployee((prev) =>
          prev
            ? {
              ...prev,
              name: editedName.trim(),
            }
            : prev
        );

        addToast({ message: "Employee name updated successfully.", status: "success", });

        setIsNamePopoverOpen(false);
      }
    } catch (error) {
      addToast({ message: "Failed to update employee name.", status: "error", });
    }
  };

  return (
    <MyDiv>
      <Box className="profile-container">
        <Box className="fixed-header">
          {myProfile ?
            <Text className="font-poppins text_semibold text_3xl">My Profile</Text> :
            <Flex className="page_heading flex_header">
              <Breadcrumb spacing='5px' className="font_poppins text_md text_medium" separator=">>">
                <BreadcrumbItem>
                  <BreadcrumbLink className="font_poppins text_md text_medium" href={routesNames.EMPLOYEES} color="gray.500">Employee</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink className="font_poppins text_md text_medium" color="gray.500" maxWidth="11vw" isTruncated _hover={{ textDecoration: "none", cursor: "default" }} >{employee?.department ?? "Department"}</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink className="font_poppins text_md text_medium" href='#' maxWidth="7vw" isTruncated>Employee Profile</BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Flex>}
        </Box>

        <Box className="scrollable-content">
          <Box className="main">
            <Box position="relative" h="140px"  >
              <Image src={BackgroundProfile} alt="Cover" w="100%" h="100%" objectFit="cover" />
              <Flex
                position="absolute" top="9px" right="8px" zIndex={2} direction="column" align="center" gap={1}>
                <Box bg="#fff" borderRadius="50px">
                  <Tooltip hasArrow placement="left" bg="white" color="black" borderRadius="md" boxShadow="lg"
                    label={<ProfileTooltip tabs={employee?.profileCompletion?.tabs} />}
                  >
                    <Box className="img_profile">
                      <CircularProgress
                        value={profilePercent}
                        size="56px" thickness="12px"
                        color={getProfileColor(profilePercent)}
                        trackColor="gray.200"
                      >
                        <CircularProgressLabel
                          fontSize="12px"
                          fontWeight="600"
                          color={getProfileColor(profilePercent)}
                        >
                          {profilePercent}%
                        </CircularProgressLabel>
                      </CircularProgress>
                    </Box>
                  </Tooltip>
                </Box>

                {canUpdateProfileCompletion && (
                  <Tooltip label="Recalculate profile completion" placement="left" hasArrow>
                    <Button
                      size="xs" bg="#006838" color="#fff" _hover={{ bg: "#005529" }} borderRadius="6px" fontSize="9px"
                      px={2} py={1} height="auto"
                      className="font-poppins text_medium"
                      onClick={() =>
                        setAlertConfig({
                          description: "Are you sure you want to recalculate profile completion?",
                          colorScheme: "green",
                          onConfirm: () => updateProfileCompletion(),
                        })
                      }
                    >
                      Update
                    </Button>
                  </Tooltip>
                )}
              </Flex>
            </Box>
            <Flex align="center" gap={4} px={5} mt={-10}>
              <Box position="relative" display="inline-block">
                <Avatar src={avatarUrl ?? DummyPerson} name={employee?.name} size="xl" />
                {hasPermission('Employee', 'UploadProfileImg') && (
                  <Box position="absolute" bottom="0" right="-1" cursor="pointer" onClick={triggerAvatarUpload}>
                    {myProfile ?
                      <Image src={UploadImageIcon} boxSize="30px" alt="Upload Icon" /> : null}
                  </Box>
                )}
                <input type="file" accept="image/*" ref={fileInputRef} style={{ display: "none" }} onChange={handleAvatarUpload}
                />
              </Box>
              <Box w="100%" mt={12}>
                <Flex justifyContent="space-between" alignItems="center" width="100%">
                  <Flex align="center" gap={2}>
                    <Tooltip label={employee?.name}>
                      <Text className="font-poppins text_xl text_medium font_dark" maxWidth="8vw" isTruncated>
                        {employee?.name}
                      </Text>
                    </Tooltip>

                    {hasPermission("Employee", "UpdateEmpName") && (
                      <Popover isOpen={isNamePopoverOpen} onClose={() => setIsNamePopoverOpen(false)} placement="bottom-start" closeOnBlur={false}>
                        <PopoverTrigger>
                          <IconButton aria-label="Edit Name" icon={<EditIcon />} size="xs" variant="ghost" onClick={() => setIsNamePopoverOpen(true)} />
                        </PopoverTrigger>
                        <PopoverContent>
                          <PopoverArrow />

                          <PopoverBody>
                            <Input value={editedName} maxLength={100} onChange={(e) => {
                              const value = e.target.value;
                              if (/^[A-Za-z .'-]*$/.test(value)) {
                                setEditedName(value);
                              }
                            }}
                            />
                            <Flex mt={3} justify="flex-end" gap={2}>
                              <Button size="sm" variant="outline" onClick={() => setIsNamePopoverOpen(false)}>Cancel</Button>
                              <Button size="sm" colorScheme="green" onClick={updateEmployeeName} >Save</Button>
                            </Flex>
                          </PopoverBody>
                        </PopoverContent>
                      </Popover>
                    )}

                  </Flex>

                  <Flex align="center" gap={2}>

                    {hasPermission('Employee', 'ShowEmployeeStatusHistory') && (
                      <Tooltip label="View status history" placement="top" hasArrow>
                        <Button
                          size="sm"
                          variant="ghost"
                          color="#006838"
                          _hover={{ bg: "#F0FFF4" }}
                          borderRadius="full"
                          minW="22px"
                          height="22px"
                          p={0}
                          onClick={fetchStatusHistory}
                        >
                          <TimeIcon boxSize="16px" />
                        </Button>
                      </Tooltip>
                    )}

                    {hasPermission('Employee', 'UpdateEmpStatus') ? (
                      <Select
                        value={statusDD.find((s) => s.employeeStatus === employee?.status)?.id.toString() ?? ""}
                        onChange={(e) => handleStatusChange(e.target.value)}
                        className="font-poppins text_medium text_xsm"
                        width="78px"
                        height="22px"
                        icon={<ChevronDownIcon ml={2} />}
                        borderRadius="4px"
                        color={employee?.status === "Active" ? "#38A169" : "#E53E3E"}
                        bg={employee?.status === "Active" ? "#F0FFF4" : "#FFF5F5"}
                        sx={{ textAlign: "left", paddingLeft: "4px" }}
                      >
                        {statusDD.map((status) => (
                          <option key={status.id} value={status.id}>{status.employeeStatus}</option>
                        ))}
                      </Select>
                    ) : (
                      <Text
                        color={employee?.status === "Active" ? "#38A169" : "#E53E3E"}
                        bg={employee?.status === "Active" ? "#F0FFF4" : "#FFF5F5"}
                        className="font-poppins text_medium text_sm"
                        maxWidth="5vw"
                      >
                        {employee?.status}
                      </Text>
                    )}


                  </Flex>
                </Flex>

                <Flex gap={3} mt={2} alignItems="center" flexWrap="wrap">
                  <Badge className="Badge font-poppins text_medium" fontSize="8px" color="rgba(0, 0, 0, 0.5)">
                    {employee?.empCode}
                    <Image src={CopyIcon} alt="Copy" boxSize="11px" cursor="pointer" onClick={(e) => { e.stopPropagation(); copyToClipboard(employee?.empCode ?? "", "Employee Code"); }} />
                  </Badge>
                  <Badge className="designation font-poppins text_sm text_medium" color="rgba(0, 122, 255, 1)">
                    <Tooltip label={employee?.designation}>
                      <Text className="font-poppins text_sm text_medium common_color" maxWidth="12vw" isTruncated>
                        {employee?.designation}
                      </Text>
                    </Tooltip>
                  </Badge>
                </Flex>
                {hasPermission("Employee", "SendAppointmentLetter") && (
                  <Flex gap={3} mt={2} alignItems="center" flexWrap="wrap">
                    <Button size="xs" onClick={() => setAlertConfig({ description: `Are you sure you want to send the appointment letter to ${employee?.name}?`, colorScheme: "green",  onConfirm: () => sendAppointmentLetter(), }) } >
                      Send Appointment Letter
                    </Button>
                  </Flex>
                )}
              </Box>
            </Flex>

            <Divider orientation="horizontal" mt={6} />

            <Box px={5} mt={6} pb={5}>
              <Text className="font-poppins text_sm text_medium" color="rgba(0, 0, 0, 1)" mb={3}>More Information</Text>

              <Box display="grid" rowGap={4}>
                {infoItems.map((item, idx) => (
                  <Flex key={idx} align="center" gap={3}>
                    <Image src={item.icon} boxSize="24px" alt={item.label} />
                    <Box>
                      <Text className="font-poppins text_medium" fontSize="9px" color="rgba(0, 0, 0, 0.5)">{item.label}</Text>
                      <Text className="font-poppins text_sm text_medium" color="rgba(0, 0, 0, 1)">{item.value}</Text>
                    </Box>
                  </Flex>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <AlertCard isOpen={isOpen} onClose={onClose} onConfirm={handleConfirmStatusChange} />

      {/* Crop Modal */}
      <Modal isOpen={cropModalOpen} onClose={() => { setCropModalOpen(false); modalDisclosure.onClose(); }} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="12px" overflow="hidden">
          <ModalHeader className="font-poppins text_medium text_lg">Edit & Upload Your Profile Picture</ModalHeader>

          <ModalBody px={6} pt={0}>
            <Box height="420px" position="relative" bg="gray.50" borderRadius="8px" overflow="hidden">
              {selectedImage ? (
                <Cropper
                  image={selectedImage}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  cropShape="round"
                  showGrid={false}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />
              ) : (
                <Box p={6}>No image selected</Box>
              )}
            </Box>

            <Box mt={4}>
              <Text className="font-poppins text_sm text_md" mb={2}>Zoom</Text>
              <Slider value={zoom} min={1} max={3} step={0.05} onChange={(v) => setZoom(v)}>
                <SliderTrack>
                  <SliderFilledTrack />
                </SliderTrack>
                <SliderThumb />
              </Slider>
            </Box>

            <Box mt={4} display="flex" gap={3} justifyContent="flex-end">
              <Button variant="outline" onClick={() => { setCropModalOpen(false); modalDisclosure.onClose(); }}>Cancel</Button>
              <Button className="font-poppins text_sm text_md" bg="#006838" variant="solid" color="#fff" _hover={{ bg: '#005529' }} onClick={applyCrop}>Apply & Upload</Button>
            </Box>
          </ModalBody>
          <ModalFooter />
        </ModalContent>
      </Modal>
      <AlertCard isOpen={!!alertConfig} onClose={() => setAlertConfig(null)}
        onConfirm={() => { alertConfig?.onConfirm?.(); setAlertConfig(null); }}
        description={alertConfig?.description || ""}
        colorScheme={alertConfig?.colorScheme || "green"}
        isLoading={isUpdatingProfile || isSendingAppointment}
      />
      {/* Remark Modal */}
      <Modal isOpen={isRemarkModalOpen} onClose={() => setIsRemarkModalOpen(false)} isCentered size="md" >
        <ModalOverlay />
        <ModalContent borderRadius="12px">
          <ModalHeader className="font-poppins text_medium text_lg">
            Add Remark
          </ModalHeader>
          <ModalBody px={6} pb={2}>
            <Text className="font-poppins text_sm" color="gray.600" mb={3}>
              Please provide a reason for changing the employee status.
            </Text>
            <textarea
              value={remarkText}
              onChange={(e) => setRemarkText(e.target.value)}
              placeholder="Enter remark here..."
              rows={4}
              style={{
                width: "100%", border: "1px solid #E2E8F0", borderRadius: "8px", padding: "10px 12px",
                fontFamily: "Poppins, sans-serif", fontSize: "13px", resize: "vertical", outline: "none",
              }}
            />

            {/* NEW — Last Working Day, only for Terminated/Release/Abscond */}
            {REQUIRES_LWD.includes(pendingStatusName ?? "") && (
              <Box mt={3}>
                <Text className="font-poppins text_sm" color="gray.600" mb={1}>
                  Last Working Day <Text as="span" color="red.500">*</Text>
                </Text>
                <Input
                  type="date"
                  value={lastWorkingDay}
                  max={new Date().toISOString().split("T")[0]} // no future date; drop if not desired
                  onChange={(e) => setLastWorkingDay(e.target.value)}
                />
              </Box>
            )}
          </ModalBody>
          <ModalFooter gap={3}>
            <Button
              variant="outline" onClick={() => setIsRemarkModalOpen(false)} className="font-poppins text_sm" >
              Cancel
            </Button>
            <Button
              bg="#006838" color="#fff" _hover={{ bg: "#005529" }} className="font-poppins text_sm text_medium" onClick={handleConfirmStatusChange}
            >
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Status History Modal */}
      <Modal
        isOpen={isHistoryModalOpen} onClose={() => setIsHistoryModalOpen(false)} isCentered
        size="lg"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent borderRadius="12px" maxH="80vh">
          <ModalHeader className="font-poppins text_medium text_lg">
            Status Change History
          </ModalHeader>
          <ModalBody px={6}>
            {isHistoryLoading ? (
              <Flex justify="center" py={8}>
                <CircularProgress isIndeterminate color="#006838" />
              </Flex>
            ) : statusHistory.length === 0 ? (
              <Text
                className="font-poppins text_sm"
                color="gray.500"
                textAlign="center"
                py={8}
              >
                No history found.
              </Text>
            ) : (
              <Box>
                {statusHistory.map((item: any, idx: number) => (
                  <Box key={idx} mb={4}>
                    <Flex gap={3} align="flex-start" p={3} bg="gray.50" borderRadius="8px" border="1px solid" borderColor="gray.100"
                    >
                      {/* Timeline dot */}
                      <Flex direction="column" align="center" pt={1}>
                        <Box
                          w="10px" h="10px" borderRadius="full" bg="#006838" flexShrink={0} />
                        {idx < statusHistory.length - 1 && (
                          <Box w="2px" flex={1} bg="gray.200" mt={1} minH="20px" />
                        )}
                      </Flex>

                      <Box flex={1}>
                        <Flex justify="space-between" align="center" mb={1}>
                          <Flex align="center" gap={2}>
                            <Badge colorScheme="red" fontSize="10px" borderRadius="4px" >
                              {item.oldStatusName}
                            </Badge>
                            <Text fontSize="11px" color="gray.400">→</Text>
                            <Badge
                              colorScheme="green" fontSize="10px" borderRadius="4px" >
                              {item.newStatusName}
                            </Badge>
                          </Flex>
                          <Text fontSize="10px" color="blue.700" className="font-poppins">
                            {showDate(item.created_At)}
                          </Text>
                        </Flex>

                        {item.remark && (
                          <Text fontSize="12px" color="gray.600" className="font-poppins" mt={1} > <Text as="span" fontWeight="600" color="gray.700"> Remark:{" "} </Text> {item.remark} </Text>
                        )}

                        <Text fontSize="12px" color="gray.700" className="font-poppins" mt={1}>Changed by: {item.createdByName ?? "—"}</Text>
                      </Box>
                    </Flex>
                  </Box>
                ))}
              </Box>
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="outline" onClick={() => setIsHistoryModalOpen(false)} className="font-poppins text_sm" >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

    </MyDiv>
  );
};

export default ProfileDetailCard;
